import { useState } from "react";
import { useFrame, useThree } from "@react-three/fiber";
import { useLayoutStore } from "../stores/layoutStore";
import { useTelemetryStore } from "../stores/telemetryStore";
import { useUIStore } from "../stores/uiStore";
import { SensorBeacon } from "./primitives/SensorBeacon";
import { SensorClusterBillboard } from "./primitives/SensorClusterBillboard";

const CLUSTER_THRESHOLD = 80;

export function SensorLayer() {
  const sensors        = useLayoutStore((s) => s.sensors);
  const sensorReadings = useTelemetryStore((s) => s.sensorReadings);
  const visible        = useUIStore((s) => s.layers.sensors);
  const { camera }     = useThree();
  const [clustered, setClustered] = useState(false);

  useFrame(() => {
    const isNow = camera.position.y > CLUSTER_THRESHOLD;
    if (isNow !== clustered) setClustered(isNow);
  });

  if (!visible || sensors.length === 0) return null;

  if (clustered) {
    return <SensorClusterBillboard sensors={sensors} readings={sensorReadings} />;
  }

  return <SensorBeacon sensors={sensors} />;
}
